import React from "react";
import styled from "styled-components";
// eslint-disable-next-line
import "twin.macro";

const WrapperCompanyInfo = styled.div`
  @media (max-width: 700px) {
    border-radius: 20px 20px 0 0;
  }
`;

const CompanyName = styled.h2`
  margin: 0 0 1rem 0;
  text-align: center;
  color: #fff;
  @media (min-width: 700px) {
    text-align: left;
  }
`;

const WrapperList = styled.ul`
  list-style: none;
  margin: 0 0 1rem 0;
  padding: 0;
  text-align: center;
  @media (min-width: 700px) {
    text-align: left;
  }
`;

const CompanyInfoData = [
  {
    title: "Address",
    content: "Location Indore, Madhya Pradesh, 452010",
  },
  {
    title: "Phone Number",
    content: "+91 6263935010",
  },
  {
    title: "Email",
    content: "contact@techtomatoes.in",
  },
];

const CompanyInfo = () => (
  <WrapperCompanyInfo>
    <CompanyName tw="text-3xl text-center">Tech Tomatoes</CompanyName>
    <WrapperList tw="space-y-10">
      {CompanyInfoData.map((item, index) => (
        <div tw="">
          <p tw="font-bold">{item.title}</p>
          <p>{item.content}</p>
        </div>
      ))}
    </WrapperList>
  </WrapperCompanyInfo>
);

export default CompanyInfo;
